import Grid from "@mui/material/Grid";
import { Button, ListItem, Box, List, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { v4 as uuidv4 } from 'uuid';
import Vehicle from "../../../../../../assets/images/sign-up/car.png";
import { vehicleDetails, vehicleInfo, motInfo } from "../../../../../../mock-data/signup-vehicle-registration-mock";
import { vehicleDetailNames, vehicleInfoNames, motInfoNames } from "../../../../../../mock-data/signup-vehicle-registration-mock";
import "./styles.scss";

export default function VehicleDetails() {
  const navigate = useNavigate();
  return (
    <Box className="Vehicle_Details">
      <h2 className="fs-24 fw-600 line-height-28 label-color">Vehicle Details</h2>
      <Box sx={{ flexGrow: 1, mt: 4 }}>
        <Grid container spacing={4}>
          <Grid item xs={6}>
            <ListItem>
              <img src={Vehicle} alt="takePhoto" />
            </ListItem>
          </Grid>
          <Grid item xs={6}>
            <Grid container>
              <Grid item xs={6}>
                <List>
                  {vehicleDetailNames.map((name) => {
                    return (
                      <ListItem key={uuidv4()} alignItems="flex-start">
                        <Typography>{name}:</Typography>
                      </ListItem>
                    );
                  })}
                </List>
              </Grid>
              <Grid item xs={6}>
                <List className="FlexEnd">
                  {vehicleDetails.map((details) => {
                    return (
                      <ListItem key={uuidv4()} className="ColorData">
                        <Typography>{details}</Typography>
                      </ListItem>
                    );
                  })}
                </List>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid container spacing={4}>
          <Grid item xs={6}>
            <h3 className="fw-700 fs-18 line-height-22 label-color">Vehicle Information</h3>

            <Grid container>
              <Grid item xs={6}>
                <List>
                  {vehicleInfoNames.map((name) => {
                    return (
                      <ListItem key={uuidv4()} alignItems="flex-start" className="HeadingDetails">
                        <Typography>{name}:</Typography>
                      </ListItem>
                    );
                  })}
                </List>
              </Grid>
              <Grid item xs={6}>
                <List className="FlexEnd">
                  {vehicleInfo.map((vehicleInfo) => {
                    return (
                      <ListItem key={uuidv4()} className="OtherDetails">
                        <Typography>{vehicleInfo}</Typography>
                      </ListItem>
                    );
                  })}
                </List>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={6}>
            <h3 className="fw-700 fs-18 line-height-22 label-color">MOT Information</h3>

            <Grid container>
              <Grid item xs={6}>
                <List>
                  {motInfoNames.map((name) => {
                    return (
                      <ListItem key={uuidv4()} alignItems="flex-start" className="HeadingDetails">
                        <Typography>{name}:</Typography>
                      </ListItem>
                    );
                  })}
                </List>
              </Grid>
              <Grid item xs={6}>
                <ListItem className="FlexEnd">
                  <List>
                    {motInfo.map((motInfo) => {
                      return (
                        <ListItem key={uuidv4()} className="OtherDetails">
                          <Typography>{motInfo}</Typography>
                        </ListItem>
                      );
                    })}
                  </List>
                </ListItem>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Box className="ConfirmVehicle" sx={{ width: { xs: "100%", md: "auto" } }}>
          <Button className="btn-primary" sx={{ width: { xs: "100%", md: "auto" } }} onClick={() => navigate("/", { replace: true })}>
            Confirm
          </Button>
        </Box>
      </Box>
    </Box>
  );
}
